module.exports = __webpack_public_path__ + "static/media/Boton_Instituto_CS.4f0a4e25.webp";